import React from "react";
import Loader from "../../../components/Loader/Loader";
import Input from "../../../components/Input/Input";
import { useSignIn } from "./useSignIn";
import { EMAIL_VALIDATION } from "../../../constants/validation";

export default function SignInPage() {
  const {
    register,
    handleSubmit,
    errors,
    isSubmitting,
    onSubmit,
    showResend,
    handleForgotPassword,
    handleResendVerification,
  } = useSignIn();

  return (
    <>
      {isSubmitting && <Loader />}
      <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
          Sign In
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          <Input
            id="email"
            label="Email"
            type="email"
            {...register("email", EMAIL_VALIDATION)}
            error={errors.email?.message}
          />

          <Input
            id="password"
            label="Password"
            type="password"
            showPasswordToggle
            autoComplete="current-password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters",
              },
            })}
            error={errors.password?.message}
          />

          <div className="flex items-center justify-between text-sm">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                className="form-checkbox text-primary"
                {...register("rememberMe")}
              />
              Remember me
            </label>
            <a
              href="/forgot-password"
              className="text-primary hover:underline"
              onClick={handleForgotPassword}
            >
              Forgot password?
            </a>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-primary text-white py-2 px-4 rounded hover:bg-primary-dark disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Sign In
          </button>
        </form>

        {showResend && (
          <div className="mt-4 rounded-md border p-3">
            <p className="text-sm text-gray-700">
              Your email isn’t verified yet. Please verify it to sign in.
            </p>
            <button
              className="mt-2 w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
              onClick={handleResendVerification}
            >
              Resend verification email
            </button>
          </div>
        )}

        {/* Optional: Link to Sign Up */}
        <p className="mt-4 text-center text-sm text-gray-600">
          Don’t have an account?{" "}
          <a
            href="/register"
            className="text-primary font-medium hover:underline"
          >
            Register
          </a>
        </p>
      </div>
    </>
  );
}
